<template>
    <div v-if="visible" :class="['fm-upload-overlay', {'fm-upload-overlay--dragover': isDragOver}]"
         @dragover.prevent="onDragOver"
         @dragleave.prevent="onDragLeave"
         @drop.prevent.stop="onDrop"
         @click.self="manualMode ? $emit('close') : null">

        <div class="fm-upload-drop-zone" :class="{'fm-upload-drop-zone--active': isDragOver}"
             @click.stop="openFilePicker">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
            <div class="fm-upload-drop-text">{{ isDragOver ? $t('common.fileManager.uploadDrop') : $t('common.fileManager.uploadDragFiles') }}</div>
            <div class="fm-upload-drop-hint">{{ $t('common.fileManager.uploadOrClick') }}</div>
            <button v-if="manualMode && !isDragOver" class="fm-upload-cancel-btn" @click.stop="$emit('close')">
                {{ $t('common.fileManager.uploadCancel') }}
            </button>
        </div>

        <input ref="fileInput" type="file" multiple style="display:none" @change="onFileSelect"/>
    </div>
</template>

<script>
import fileManagerService from './fileManagerService'

export default {
    name: 'FileManagerUploadOverlay',
    props: {
        visible: { type: Boolean, default: false },
        manualMode: { type: Boolean, default: false },
        uploadModule: { type: String, default: null },
        uploadEntityId: { type: [Number, String], default: null },
    },
    emits: ['close', 'filesDropped'],
    data() {
        return {
            isDragOver: false,
        }
    },
    methods: {
        onDragOver(e) {
            e.dataTransfer.dropEffect = 'copy'
            this.isDragOver = true
        },
        onDragLeave(e) {
            if (e.currentTarget.contains(e.relatedTarget)) return
            this.isDragOver = false
        },
        onDrop(e) {
            this.isDragOver = false
            const files = e.dataTransfer?.files
            if (files && files.length) {
                const opts = this.uploadModule ? { module: this.uploadModule, moduleEntityId: this.uploadEntityId } : undefined
                fileManagerService.uploadFiles(Array.from(files), opts)
            }
            this.$emit('close')
        },
        openFilePicker() {
            this.$refs.fileInput?.click()
        },
        onFileSelect(e) {
            const files = e.target.files
            if (files && files.length) {
                const opts = this.uploadModule ? { module: this.uploadModule, moduleEntityId: this.uploadEntityId } : undefined
                fileManagerService.uploadFiles(Array.from(files), opts)
            }
            e.target.value = ''
            this.$emit('close')
        },
    },
}
</script>
